import axios from "../axios";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_REPORT_URL ?? `${hostConfig.apiBaseUrl}/reporting-service`;

const pbiBase = baseUrl + "/api/v1/reports/powerbi";

class PowerBIReportService {
  getAllReports() {
    return axios
      .get(pbiBase + "/all")
      .then((response) => {
        return response.data.reports;
      })
      .catch((error) => {
        console.log("Error fetching all reports", error.response);
        return error;
      });
  }

  getConfigs() {
    return axios
      .get(pbiBase + "/config")
      .then((response) => {
        return response.data.configs;
      })
      .catch((error) => {
        console.log("Error fetching PBI configs", error.response);
        return error;
      });
  }

  getConfig(id) {
    return axios
      .get(pbiBase + "/config/" + id)
      .then((response) => {
        return response.data.config;
      })
      .catch((error) => {
        console.log("Error fetching PBI config", error.response);
        return error;
      });
  }

  createConfig(data) {
    return axios
      .post(pbiBase + "/config", data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error creating PBI config", error.response);
        return error;
      });
  }

  updateConfig(id, data) {
    return axios
      .put(pbiBase + "/config/" + id, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error updating PBI config", error.response);
        return error;
      });
  }

  deleteConfig(id) {
    return axios
      .delete(pbiBase + "/config/" + id)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error deleting PBI config", error.response);
        return error;
      });
  }

  getEmbedToken(configId, clientId) {
    return axios
      .post(pbiBase + "/embed-token", { configId, clientId })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error fetching embed token", error.response);
        return error;
      });
  }
}

export default new PowerBIReportService();
